// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2KlNz","col":"styles_col__3Zhka"};